import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { Section } from '../../src/components/Layout';
import { Container } from '../../src/components/Grid';

import { Query } from 'react-apollo';
import getQuestions from '../../src/apollo/graphql/faq/getQuestions';
import Collapsible from '../../src/components/Collapsible';
import createContext from '../../src/utils/format/createContext';

const QuestionContainer = styled(Container)`
  max-width: ${props => props.theme.layout.width - (props.theme.layout.gutter * 10)}px;
`;

class Questions extends React.PureComponent {
  renderQuestion = (data, index) => {
    return (
      <Collapsible key={index} title={data.detail.question} content={data.detail.response} />
    );
  }

  render() {
    const { i18n } = this.props;
    return (
      <Query query={getQuestions} context={createContext(i18n.language)}>
        {({ loading, error, data }) => {

          if (!loading && !error && data && data.getQuestions) {
            const FAQ = data.getQuestions;

            return (
              <Section>
                <QuestionContainer>
                  {FAQ.map(this.renderQuestion)}
                </QuestionContainer>
              </Section>
            );
          }

          return null;
        }}
      </Query>
    );
  }
}

Questions.propTypes = {
  i18n: PropTypes.object,
}


export default translate()(Questions);
